// extracted by mini-css-extract-plugin
var _1 = "webpack-pages-EligibilityCriteria-components-ExclusionsModal-ExclusionModal-module__apiErrorMessage";
export { _1 as "apiErrorMessage" }
